// extracted by mini-css-extract-plugin
module.exports = {"toggleLayout":"styles_toggleLayout__GYoiS","togglePrivate":"styles_togglePrivate__aeTlr"};